import React from 'react'
import CustomAgGridTable from '../Common-Table/CustomAgGridTable'
import { Card, Collapse, Icon } from 'antd'
import Pagination from '../components/pagination'
import { Translate } from 'react-translated'
const { Panel } = Collapse;


const AccordionPanel = (
    {
        headerText,
        loading,
        rowDatas,
        columnDefs,
        currentPage,
        totalPages,
        onPageChange,
        panelKey,
    }
) => {
    return (
        <Card type="inner" className="tableCard" loading={loading}>
            <CustomAgGridTable
                key={`grid-${panelKey}`}
                rowDatas={rowDatas}
                columnDefss={columnDefs}
            />
            <div className="pagination-div-container">
                <Pagination
                    current_page={currentPage}
                    total_pages={totalPages}
                    onClick={onPageChange}
                />
            </div>
        </Card>
    )
}

export default AccordionPanel


// WEBPACK FOOTER //
// ./src/components/AccordionPanel.js